import type { PostHog } from 'posthog-js/react';

/**
 * Utility function that accesses PostHog instance from window.analytics
 * (loaded via HTML script tag).
 *
 * This can be used outside React components (e.g., in xstate files).
 *
 * @returns PostHog instance or null if not available
 */
export function getPostHogAnalytics(): PostHog | null {
  // Always use window.analytics (loaded from HTML script tag)
  if (typeof window !== 'undefined' && window.analytics) {
    return window.analytics;
  }

  return null;
}

/**
 * Custom hook that accesses PostHog instance from window.analytics
 * (loaded via HTML script tag).
 *
 * This hook provides access to PostHog for opt-in/opt-out, user identification,
 * initialization, and custom event capture.
 *
 * Use this hook inside React components. For use outside React components,
 * use `getPostHogAnalytics()` instead.
 *
 * @returns PostHog instance or null if not available
 */
export function usePostHogAnalytics(): PostHog | null {
  return getPostHogAnalytics();
}
